import Swiper from 'swiper';
import { Thumbs } from "swiper/modules";  // Импортируем модуль Zoom
import 'swiper/css';
import 'swiper/css/thumbs';
import './zoom';
import 'swiper/css/zoom'; // Импортируем стили для Zoom
import '../styles/swiper-product-details.css';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
// import './jquery.zoom';
// Определяем тач-устройство
const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
// Инициализация thumb-slider
const thumbSlider = new Swiper(".thumb-slider", {
    direction: 'vertical',
    slidesPerView: 6,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
});

// Инициализация main-slider с модулем Zoom
const mainSlider = new Swiper(".main-slider", {
    modules: [Thumbs],
    slidesPerView: 1,
    spaceBetween: 10,
    thumbs: {
        swiper: thumbSlider,
    },
});

// Обновление слайдеров
export function updateSliders() {

    if (mainSlider) {
        mainSlider.update();  // Обновляем основной слайдер
    }

    if (thumbSlider) {
        thumbSlider.update();  // Обновляем миниатюрный слайдер
    }

    zoomSwiperImages();

}

// Инициализация Swiper отзывов
const swiper_reviews = new Swiper('.swiper-container-reviews', {
    slidesPerView: "auto", // Количество слайдов на экране
    spaceBetween: 5, // Отступы между слайдами
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1024: { slidesPerView: 9 },
        768: { slidesPerView: 3 },
        480: { slidesPerView: 2 },
    }
});

var swiper = new Swiper(".swiper-container-reviews", {
    slidesPerView: "auto", // Автоматическая подстройка количества слайдов
    spaceBetween: 10, // Отступы между слайдами
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});


// Применяем зум
function zoomSwiperImages() {
    if (!isTouchDevice) {
        const zoomElements = document.querySelectorAll('.swiper-zoom-container'); // выбираем элемент, для которого хотим включить зум
        zoomElements.forEach(function (zoomElement) {
            let img = zoomElement.querySelector('img');

            if (img) {
                zoomElement.zoom();
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    // Инициализация зума для элемента с классом .zoom-container
    zoomSwiperImages()
});

// Инициализация Fancybox для фото и видео
Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Toolbar: true,
    Video: {
        autoplay: true,
        controls: true
    }
});